import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { selectQuizTemplateById } from 'features/quizzes/quizzesSlice';
import { usePollTemplates } from 'features/polls/hooks/usePollTemplates';
import { deleteQuizTemplateRequested } from 'features/quizzes/actions';

const DeleteQuizTemplateConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const templateId = modalData.id as string;

  const { templatesAvailable, canManageTemplates } = usePollTemplates();

  const template = useAppSelector((state) => selectQuizTemplateById(state, templateId));

  const shouldClose = !templatesAvailable || !canManageTemplates || !template;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('deleteQuizTemplate'));
    }
  }, [shouldClose, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('deleteQuizTemplate'));
  };

  const handleOk = () => {
    dispatch(deleteQuizTemplateRequested({ id: templateId }));
    dispatch(closeModal('deleteQuizTemplate'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      title={t('quizzes.delete_quiz_template.title')}
      description={t('quizzes.delete_quiz_template.description')}
      cancelText={t('quizzes.delete_quiz_template.btn_cancel_label')}
      okText={t('quizzes.delete_quiz_template.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default DeleteQuizTemplateConfirmation;
